import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startLoadingCatalogsAll } from '../actions/catalogActions';
import { startLoadingCountries } from '../actions/countryActions';
import { getObjectById } from '../helpers/getObjectById';

const SIMPLE_CATALOGS = [
  ['catalogserie_id', 'CatalogSerie_To_', 'listSeries'],
  ['catalogpricerange_id', 'CatalogPriceRange_To_', 'listPriceRanges'],
  ['catalogmeasure_id', 'CatalogMeasure_To_', 'listMeasures'],
  ['catalogstrategy_id', 'CatalogStrategy_To_', 'listStrategies'],
  ['catalogamplitude_id', 'CatalogAmplitude_To_', 'listAmplitudes'],
  ['catalogmitigation_id', 'CatalogMitigation_To_', 'listMitigations'],
  ['catalogproblem_id', 'CatalogProblem_To_', 'listProblems'],
  ['catalogsophistication_id', 'CatalogSophistication_To_', 'listSophistications'],
  ['catalogmagnitude_id', 'CatalogMagnitude_To_', 'listMagnitudes'],
  ['catalogsize_id', 'CatalogSize_To_', 'listSizes'],
  ['catalogtypology_id', 'CatalogTypology_To_', 'listTypologies'],
  ['catalogconcern_id', 'CatalogConcern_To_', 'listConcerns'],
  ['catalogpermissionpublish_id', 'CatalogPermissionPublish_To_', 'listPermissionPublish'],
  ['catalogcomplexity_id', 'CatalogComplexity_To_', 'listComplexities'],
];

const findById = (id, list) => {
  if (!id || !Array.isArray(list) || list.length === 0) {
    return null;
  }
  return getObjectById(id, list) || getObjectById(Number(id), list) || null;
};

/**
 * La ficha recibe el id del catálogo. Este efecto carga el listado y
 * deja el objeto en la key_relation que ya usa ViewTextGenericCatalog.
 */
export const useHydrateViewCatalogRelations = (relationSuffix, values, setValues) => {
  const dispatch = useDispatch();
  const catalogs = useSelector((state) => state.catalog);
  const listFullCountries = useSelector((state) => state.locationCountry.listFullCountries);

  useEffect(() => {
    dispatch(startLoadingCatalogsAll());
    dispatch(startLoadingCountries());
  }, [dispatch]);

  const recordId = values?.id;
  const idSignature = SIMPLE_CATALOGS
    .map(([idField]) => values?.[idField] || '')
    .concat(values?.catalogcountries_id || '')
    .join('|');

  useEffect(() => {
    if (!values || !relationSuffix || typeof setValues !== 'function') {
      return undefined;
    }

    const patch = {};

    SIMPLE_CATALOGS.forEach(([idField, prefix, listKey]) => {
      const relationKey = `${prefix}${relationSuffix}`;
      if (values[relationKey] && String(values[relationKey].description || '').trim()) {
        return;
      }
      const found = findById(values[idField], catalogs[listKey]);
      if (found) {
        patch[relationKey] = found;
      }
    });

    const countryKey = `CatalogCountry_To_${relationSuffix}`;
    const country = findById(values.catalogcountries_id, listFullCountries);
    if (country && !(values[countryKey] && values[countryKey].name)) {
      patch[countryKey] = country;
    }

    if (Object.keys(patch).length === 0) {
      return undefined;
    }

    setValues((current) => ({ ...current, ...patch }));
    return undefined;
  }, [
    relationSuffix,
    setValues,
    recordId,
    idSignature,
    listFullCountries,
    catalogs.listSeries,
    catalogs.listPriceRanges,
    catalogs.listMeasures,
    catalogs.listStrategies,
    catalogs.listAmplitudes,
    catalogs.listMitigations,
    catalogs.listProblems,
    catalogs.listSophistications,
    catalogs.listMagnitudes,
    catalogs.listSizes,
    catalogs.listTypologies,
    catalogs.listConcerns,
    catalogs.listPermissionPublish,
    catalogs.listComplexities,
  ]);
};
